// extracted by mini-css-extract-plugin
export default {"container":"audit-logs-page_container__oLJD1","select":"audit-logs-page_select__VVW-J","button":"audit-logs-page_button__HTZ3J"};